import { render, staticRenderFns } from "./ActiveProductColorsAndDesigns.vue?vue&type=template&id=575a7ba5&"
import script from "./ActiveProductColorsAndDesigns.vue?vue&type=script&lang=js&"
export * from "./ActiveProductColorsAndDesigns.vue?vue&type=script&lang=js&"
import style0 from "./ActiveProductColorsAndDesigns.vue?vue&type=style&index=0&id=575a7ba5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports